// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface SetPendingQuantityParameter {
    pendingQuantity: number;
}

type HandlerType = Handler<SetPendingQuantityParameter>;

export const DispatchSetPendingQuantity: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/SetPendingQuantity",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetPendingQuantity];

const setPendingQuantity = createHandlerChainRunner(chain, "SetPendingQuantity");
export default setPendingQuantity;
